import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/TermsAndConditions/components/SectionContent/SectionContent.module.scss';

const cn = classNames.bind(styles);

const SectionContent = (): ReactElement => {
  return (
    <section className={cn('content')}>
      <div className={cn('container')}>

        <div className={cn('item')}>
          <p className={cn('item__paragraph')}>
            DF Alliance is a subscription membership platform which enables members to connect
            with freight forwarders and provide networking opportunities.
            This website{' '}
            <Link
              className={cn('item__link')}
              href='https://www.df-alliance.com'
            >
              df-alliance.com
            </Link>{' '}
            is provided by DF Alliance FZE, owned by DP World. We are registered in the
            United Arab Emirates under Jebel Ali Free Zone Licence Number 183847 and have
            our business address at 5th Floor, Jafza 17, Jebel Ali Free Zone, Dubai, UAE.
            To contact us, please email{' '}
            <a
              className={cn('item__link')}
              href='mailto:info@df-alliance.com'
            >
              info@df-alliance.com
            </a>{' '}
            or telephone{' '}
            <a
              className={cn('item__link')}
              href='tel:+18886600703'
            >
              +1 888 66 00 703
            </a>.
          </p>
        </div>

        {/* 1. SUBJECT OF THE TERMS & CONDITIONS */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            1. SUBJECT OF THE TERMS & CONDITIONS
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>1.1.</span>{' '}
              The Terms & Conditions set forth the mutual relations of the Parties, connected with
              offering of “Digital Freight Alliance” membership which enables the Client to participate
              in all available services according to the most current version of the DFA “Membership Kit”
              found of the Digital Freight Alliance Website at{' '}
              <a
                className={cn('item__link')}
                href='https://www.df-alliance.com'
              >
                www.df-alliance.com
              </a>{' '}
              in exchange for payment to the Contractor (the “DFA Membership”) for the Services included
              within the DFA Membership as described herein below.
            </li>
          </ul>
        </div>

        {/* 2. SUM OF THE CONTRACT AND PAYMENT PROCEDURE */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            2. SUM OF THE CONTRACT AND PAYMENT PROCEDURE
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>2.1.</span>{' '}
              The annual DFA Membership payment shall be sent by means of bank wire transfer from
              the bank account of the Client to the bank account of the Contractor as set forth in this
              Contract. Payment is to be made prior to the commencement of the DFA Membership. For each
              subsequent year’s membership, an invoice will be issued on the renewal date, and shall
              be settled by the client within 30 days of the invoice date.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>2.2.</span>{' '}
              All relevant bank commissions and charges shall be covered by the Client at its own expense.
            </li>
          </ul>
        </div>

        {/* 3. DUTIES OF THE PARTIES */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            3. DUTIES OF THE PARTIES
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.1.</span>{' '}
              Contractor’s Duties
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.1.1.</span>{' '}
              To provide the Client with the following services:
              <ul className={cn('item__sublist')}>
                <li className={cn('item__sublist-item')}>
                  <span className={cn('item__bold')}>1)</span>{' '}
                  Logistics Explorer – A widget that can be placed on the Client’s own website
                  to allow them to sell freight services online.
                </li>
                <li className={cn('item__sublist-item')}>
                  <span className={cn('item__bold')}>2)</span>{' '}
                  Container Tracking – A widget that can be placed on the Client’s own website
                  to track containers globally using a container number with participating carriers.
                </li>
                <li className={cn('item__sublist-item')}>
                  <span className={cn('item__bold')}>3)</span>{' '}
                  Ship Schedules – A widget that can be placed on the Client’s own website to
                  allow them to check vessel schedules with participating carriers.
                </li>
                <li className={cn('item__sublist-item')}>
                  <span className={cn('item__bold')}>4)</span>{' '}
                  Rates advertisement on SeaRates.com – Largest tariff search engine in the world
                  for international shipping.
                </li>
                <li className={cn('item__sublist-item')}>
                  <span className={cn('item__bold')}>5)</span>{' '}
                  Payment Protection.
                </li>
                <li className={cn('item__sublist-item')}>
                  <span className={cn('item__bold')}>6)</span>{' '}
                  In order to provide the Services, the following software will be integrated on the Client’s
                  website with the use of IFrame technology:
                  <ul className={cn('item__sublist')}>
                    <li className={cn('item__sublist-item')}>
                      <span className={cn('item__bold')}>a)</span>{' '}
                      Logistics Explorer – freight calculation tool, with access to booking system and
                      rate management system.
                    </li>
                    <li className={cn('item__sublist-item')}>
                      <span className={cn('item__bold')}>b)</span>{' '}
                      Container Tracking – online cargo tracking tool, aggregating data from multiple
                      shipping lines. 100 unique container searches per month available with a Premium
                      subscription, all of the above are paid extra. 300 unique container searches per
                      month available with a Premium Plus subscription, all of the above are paid extra.
                    </li>
                    <li className={cn('item__sublist-item')}>
                      <span className={cn('item__bold')}>c)</span>{' '}
                      Ship Schedules – check vessel schedules online, aggregating data from multiple
                      shipping lines. 600 searches per month are available with a Premium and Premium Plus
                      subscription, all of the above are paid extra.
                    </li>
                  </ul>
                </li>
                <li className={cn('item__sublist-item')}>
                  <span className={cn('item__bold')}>7)</span>{' '}
                  To make all reasonable efforts to provide the additional services available to the
                  Digital Freight Alliance as per the most current Member’s kit available on the Digital
                  Freight Alliance website at{' '}
                  <a
                    className={cn('item__link')}
                    href='https://www.df-alliance.com'
                  >
                    www.df-alliance.com
                  </a>.
                </li>
              </ul>
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.1.2.</span>{' '}
              The Contractor undertakes to assist in integration of the Software on the Client’s website.
              The contractor agrees to provide a standard set of integrations, and is not obligated to
              adapt the standard integrations to the Client’s own internal systems. Any customizations required
              will require a separate Statement of Work (SOW) to be completed and agreed upon by the Parties, and
              the Client understands that customizations may be subject to additional cost.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.1.3.</span>{' '}
              We do not exclude or limit in any way our liability to you where it would be unlawful to do so.
              This includes liability for death or personal injury caused by our negligence or the negligence
              of our employees, agents or subcontractors and for fraud or fraudulent misrepresentation.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.1.4.</span>{' '}
              Different limitations and exclusions of liability will apply to liability arising as a result
              of the supply of any additional services to you, which will be set out in the relevant Membership Agreement.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.1.5.</span>{' '}
              We exclude all implied conditions, warranties, representations or other terms that
              may apply to our Site or any content on it.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.1.6.</span>{' '}
              We will not be liable to you for any loss or damage, whether in contract, tort
              (including negligence), breach of statutory duty, or otherwise, even if foreseeable,
              arising under or in connection with:
              <ul className={cn('item__sublist')}>
                <li className={cn('item__sublist-item')}>
                  &#8226; use of, or inability to use our Site;
                </li>
                <li className={cn('item__sublist-item')}>
                  &#8226; use of or reliance on any content displayed on our Site;
                </li>
                <li className={cn('item__sublist-item', 'disc')}>
                  &#8226; for any standard (free) members actions, all scam risks are on members themselves.
                </li>
              </ul>
              <p className={cn('item__paragraph')}>In particular, we will not be liable for:</p>
              <ul className={cn('item__sublist-item')}>
                <li className={cn('item__sublist-item')}>
                  &#8226; loss of profits, sales, business, or revenue;
                </li>
                <li className={cn('item__sublist-item')}>
                  &#8226; business interruption;
                </li>
                <li className={cn('item__sublist-item')}>
                  &#8226; use of or reliance on any content displayed on our Site;
                </li>
                <li className={cn('item__sublist-item')}>
                  &#8226; loss of anticipated savings;
                </li>
                <li className={cn('item__sublist-item')}>
                  &#8226; loss of business opportunity, goodwill or reputation; or
                </li>
                <li className={cn('item__sublist-item')}>
                  &#8226; any indirect or consequential loss or damage.
                </li>
              </ul>
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.1.7.</span>{' '}
              We do not guarantee that our Site will be secure or free from bugs or viruses.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.2.</span>{' '}
              Duties of the Client
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.2.1.</span>{' '}
              To timely pay the Contractor’s invoices in accordance with the terms and conditions of this Contract.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.2.2.</span>{' '}
              The member undertakes not to disclose confidential information relating to the client,
              especially in regards of fees paid, including terms and size of discounts, and any other its terms.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.2.3.</span>{' '}
              To refrain from transferring the Software as a whole or any part thereof developed by
              the Contractor to any third party in any form and at any time.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.2.4.</span>{' '}
              To supply and maintain on a minimum of a monthly basis their own origin / destination charges
              and freight rates for a minimum number of trade lanes to be agreed upon in writing with the
              Client’s Account Manager to be published on the SeaRates, AirRates, or LandRates platforms.
              The rates to be provided should cover modes of transportation agreed upon with the same
              Account Manager in writing.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.2.5.</span>{' '}
              To initiate discussions about potential business opportunities and collaborate with
              a minimum of five (5) users of the DFA Membership Services.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.2.6.</span>{' '}
              You are responsible for configuring your information technology, computer programs and
              platform to access our Site. You should use your own virus protection software.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>3.2.7.</span>{' '}
              You must not misuse our Site by knowingly introducing
              viruses, trojans, worms, logic bombs or other material that is malicious or technologically harmful. You must
              not attempt to gain unauthorized access to our Site, the server on which our Site is stored or any server,
              computer or database connected to our Site. We will report any such breach to the relevant law enforcement
              authorities and we will co-operate with those authorities by disclosing your identity to them. In the event of
              such a breach, your right to use our Site will cease immediately.
            </li>
          </ul>
        </div>

        {/* 4. MEMBERS' RESPONSIBILITIES */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            4. MEMBERS' RESPONSIBILITIES
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>4.1.</span>{' '}
              Please note that the standard (free) membership is intended to give you a holistic view
              of the network, the opportunity to try digital tools, membership certificate and badge.
              There is no guarantee of payment and the DFA team will not be involved in any dispute if
              you book with another DFA partner.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>4.2.</span>{' '}
              Premium members are not covered by DFA Payment Protection Plan for any transaction
              losses with standard members. Our protection plan covers only 90% of ocean freight
              invoices for transactions between verified premium members that have been reported
              in advance to DFA{' '}
              <a
                className={cn('item__link')}
                href='/company/contact-us'
              >
                Support
              </a>.
            </li>
          </ul>
        </div>

        {/* 5. TERMS AND CONDITIONS OF USING CONTRACTOR’S WEBSITE */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            5. TERMS AND CONDITIONS OF USING CONTRACTOR’S WEBSITE
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              By using our Site, you confirm that you accept these terms of use (“Terms”) and that you
              agree to comply with them. If you do not agree to these Terms, you must not use our Site.
              We recommend that you print a copy of these Terms for future reference. For the purpose
              of these Terms & Conditions the “Website” shall mean the contractor website with the
              following names:{' '}
              <a className={cn('item__link')} href="https://www.df-alliance.com">www.df-alliance.com</a>,{' '}
              <a className={cn('item__link')} href="https://www.searates.com">www.searates.com</a>,{' '}
              <a className={cn('item__link')} href="https://www.landrates.com">www.landrates.com</a>,{' '}
              <a className={cn('item__link')} href="https://www.airrates.com">www.airrates.com</a>.
            </li>
            <li className={cn('item__list-item')}>
              The terms and conditions of using the Contractor’s website shall be applicable to the user
              or viewer of the Contractor’s website and to the Services provided in connection therewith
              and to the DFA membership. The use of the Contractor’s website is subject to the following
              terms of use:
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.1.</span>{' '}
              The content of the pages of the Contractor’s Website is for the Client’s general information
              and use only. It is subject to change without notice.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.2.</span>{' '}
              The Contractor’s Website contains material which is owned by or licensed to the Contractor.
              This material includes, but is not limited to, the design, layout, look, appearance and
              graphics. Reproduction is prohibited without the express, written permission of Contractor.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.3.</span>{' '}
              The Client’s use of any information or materials on the Contractor’s Websites is entirely
              at the Client’s own risk, for which the Contractor shall not be held liable. It shall be
              the Client’s own responsibility to ensure that any products, services or information
              available through the Contractor’s Websites meet the Client’s own specific requirements.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.4.</span>{' '}
              Neither the Contractor nor any third parties hereby provide any warranty or guarantee as to
              the accuracy, timeliness, performance, completeness or suitability of the information and
              materials found or offered on the Contractor’s Websites for any particular purpose.
              The Client hereby acknowledges that such information and materials may contain inaccuracies
              or errors not due to the Contractor’s fault and the Contractor expressly excludes liability
              for any such inaccuracies or errors to the fullest extent permitted by applicable law.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.5.</span>{' '}
              All trademarks reproduced on the Contractor’s Websites, if any, which are not the property
              of, or licensed to the Contractor, are acknowledged on the Websites.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.6.</span>{' '}
              Unauthorized use of the Contractor’s Websites may give rise to a claim for damages and/or
              be a criminal offense.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.7.</span>{' '}
              From time to time the Contractor’s Website may also include links to other website(s).
              These links are provided for convenience and for general information only and do not signify
              that the Contractor endorses such website(s). The Contractor has no responsibility for the
              content of the linked website(s) except to the extent that such liability is expressly set
              forth in corresponding written agreements.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.8.</span>{' '}
              The Client shall not create a link to the Contractor’s Website from another website or
              document without the express, prior written consent of the Contractor. You may link to our
              home page, provided you do so in a way that is fair and legal and does not damage our
              reputation or take advantage of it. You must not establish a link in such a way as to suggest
              any form of association, approval or endorsement on our part where none exists. You must not
              establish a link to our Site in any website that is not owned by you. Our Site must not be
              framed on any other Site, nor may you create a link to any part of our Site other than the
              home page. We reserve the right to withdraw linking permission without notice.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.9.</span>{' '}
              The Client’s use of the Contractor’s Websites and any dispute arising out of such use of
              the websites is subject to the laws of UAE as further set forth in this Contract.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.10.</span>{' '}
              The Contractor, together with platforms under the name of SeaRates, AirRates and LandRates,
              are the part of DP World corporation, with the legal entity behind it, registered in Dubai –
              DP World Logistics FZE.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.11.</span>{' '}
              We amend these Terms from time to time. Every time you wish to use our Site, please check
              these Terms to ensure you understand the terms that apply at that time.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.12.</span>{' '}
              We may update and change our Site from time to time to reflect changes to our products,
              users' needs and our business priorities.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.13.</span>{' '}
              We do not guarantee that our Site, or any content on it, will always be available or
              be uninterrupted. We may suspend or withdraw or restrict the availability of all or any
              part of our Site for business and operational reasons. We will try to give you reasonable
              notice of any suspension or withdrawal.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.14.</span>{' '}
              You are also responsible for ensuring that all persons who access our Site through
              your internet connection are aware of these Terms of use and other applicable terms and
              conditions, and that they comply with them.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.15.</span>{' '}
              We are the owner or the licensee of all intellectual property rights in our Site,
              and in the material published on it. Those works are protected by copyright laws
              and treaties around the world. All such rights are reserved.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.16.</span>{' '}
              You may print off one copy, and may download extracts, of any page(s) from our Site
              for your personal use and you may draw the attention of others within your organization to
              content posted on our Site.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.17.</span>{' '}
              You must not modify the paper or digital copies of any materials you have printed
              off or downloaded in any way, and you must not use any illustrations, photographs,
              video or audio sequences or any graphics separately from any accompanying text.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.18.</span>{' '}
              Our status (and that of any identified contributors) as the authors of content on our
              Site must always be acknowledged.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.19.</span>{' '}
              You must not use any part of the content on our Site for commercial purposes without
              obtaining a licence to do so from us or our licensors.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.20.</span>{' '}
              If you print off, copy or download any part of our Site in breach of these Terms, your
              right to use our Site will cease immediately and you must, at our option, return or destroy
              any copies of the materials you have made.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.21.</span>{' '}
              The content on our Site is provided for general information only. It is not intended to
              amount to advice on which you should rely. You must obtain professional or specialist advice
              before taking, or refraining from, any action on the basis of the content on our Site.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.22.</span>{' '}
              Although we make reasonable efforts to update the information on our Site, we make no
              representations, warranties or guarantees, whether express or implied, that the content on
              our Site is accurate, complete or up to date.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.23.</span>{' '}
              Where our Site contains links to other sites and resources provided by third parties,
              these links are provided for your information only. Such links should not be interpreted as
              approval by us of those linked websites or information you may obtain from them.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.24.</span>{' '}
              We have no control over the contents of those sites or resources and we accept no
              liability for content or loss caused as a result of using such third-party sites.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>5.25.</span>{' '}
              The Contractor may in its sole discretion exclude the Client from this website and the
              “Digital Freight Alliance” membership, temporarily suspend membership for the duration of the
              dispute, in the event that the Contractor or its affiliated companies or platforms are in any legal
              proceedings or disputes with Client, or in the event that the Client is blacklisted or sanctioned at any time
              by any authority in any jurisdiction (including without limitation the US, EU, UK or UN authorities).
            </li>
          </ul>
        </div>

        {/* 6. LINKED PLATFORMS */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            6. LINKED PLATFORMS
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>6.1.</span>{' '}
              By accessing the DFA Platform, the Client may link, access and use other
              online platforms provided by DP World and/or its affiliated companies and organizations, including but not
              limited to CARGOES FINANCE and CARGOES FLOW. The Client consents to the sharing of information, including
              registration details and contact information, which is provided in connection with access to the DFA Platform,
              to such other affiliated companies and other platforms. The use of such other online platforms shall be
              subject to the terms and conditions, and privacy policies, which are published on such other platforms from
              time to time, and any other contracts or terms of service which may be required by the operators of such other
              platforms.”
            </li>
          </ul>
        </div>

        {/* 7. PRIVACY AND DISPUTE RESOLUTION */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            7. PRIVACY AND DISPUTE RESOLUTION
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>7.1.</span>{' '}
              To the extent these Terms & Conditions provides the Contractor the right
              to receive information concerning the Client’s customers, or to the extent that the Client provides the
              Contractor with personal information relating to any employees who are identified as contact persons or
              otherwise identified herein, the Client hereby agrees to have provided all relevant notices to such persons or
              obtained any consents required to enable the Client to share this information with the Contractor. The
              Contractor will only use the information in accordance with the provisions of this Contract or as otherwise
              stated at the time the Contractor collects such information. Any data provided may be maintained by the
              Contractor in data centers in the Ukraine and may be accessible by the Contractor’s global personnel as
              required for business purposes.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>7.2.</span>{' '}
              These Terms, their subject matter and their formation, are governed by the laws of the
              United Arab Emirates as applicable in Dubai and Dubai courts will have exclusive jurisdiction
              over any disputes.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>7.3.</span>{' '}
              In case of any disputes arising in connection with the performance by the Parties of
              these Terms & Conditions, the Parties shall use their best efforts and take all possible measures
              to settle such disputes by way of negotiations. In such case, the injured Party may submit a claim to the
              Party at fault within one month from the moment of reason that caused the dispute has arisen. The Party at
              fault shall respond to claim on the point within one month from the moment of claim’s receiving.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>7.4.</span>{' '}
              In the event of the failure to settle any disputes by way of negotiations, the Parties
              shall submit such disputes for the consideration of the relevant court in the UAE.
              All disputes between the Parties are to be decided on the basis of Laws of the UAE.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>7.5.</span>{' '}
              These Terms of use refer to the following additional terms, which also
              apply to your use of our Site:
              <ul className={cn('item__sublist')}>
                <li className={cn('item__sublist-item')}>
                  &bull; Our Privacy Policy which sets out the terms on which we process any personal data we collect from you, or
                  that you provide to us. By using our Site, you consent to such processing and you warrant that all data
                  provided by you is accurate;
                </li>
                <li className={cn('item__sublist-item')}>
                  &bull; Any membership agreement(s) that you enter into with us.
                </li>
              </ul>
            </li>
          </ul>
        </div>

        {/* 8. TERMINATION AND CANCELATION */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            8. TERMINATION AND CANCELATION
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>8.1.</span>{' '}
              Membership in the DFA will automatically renew for an additional twelve (12) month period unless
              a written cancelation notice is provided by either party to the other party a minimum of thirty
              (30) calendar days in advance.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>8.2.</span>{' '}
              Should the Client be found in breach of the DFA Membership requirements
              established under section three (3) of this Contract, a written notification will be submitted to the Client,
              and a reasonable remediation period to bring the Client into compliance shall be established. If the Client is
              still found to be in breach after the established remediation period, the Contractor reserves the right to
              declare this Contract null & void, and the pro-rated annual fees paid by the Client for services that will not
              be enjoyed shall be returned to the client within thirty (30) calendar days.
            </li>
          </ul>
        </div>

        {/* 9. ACCUSATIONS AND BLACKLISTING */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            9. ACCUSATIONS AND BLACKLISTING
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              In the event that a network member receives allegations from other members or non-members
              regarding the non-payment of debt or other financial unreliability of the DFA member,
              other serious claims or accusations with proofs and evidences that caused material or
              reputational losses to the network or to other members, the network reserves the right
              to notify other members of such allegations. Additionally, the network may execute
              blacklisting, including relevant comments and evidence supporting the accusation, to
              ensure transparency and protect the interests of other participants.
            </li>
          </ul>
        </div>

        {/* 10. PERSONAL DATA PROTECTION */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            10. PERSONAL DATA PROTECTION
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>10.1.</span>{' '}
              For the purpose of these Terms & Conditions , "personal data", "processing", "data subject",
              "data controller", "data processor" and "supervisory authority" shall have the meanings set
              out in the applicable data protection legislation. The Parties hereby acknowledge that it is
              inherent to the Services that the Parties may reveal personal data which are being presented
              through the Services and that may be shared with third parties. With regard to the personal
              data submitted by the Parties to each other which are recorded in databases and processed,
              the Parties hereby undertake to comply with the applicable data protection legislation. The
              Parties hereby warrant having received all prior, individual and necessary approvals and
              authorizations from its employees, contractors, sub-contractors and other third parties to
              allow the Parties to process personal data.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>10.2.</span>{' '}
              The Parties hereby acknowledge that it is inherent to the Services that
              the Parties may collect and process personal data of its employees, contractors, sub-contractors,
              users and/or third parties (including other customers) and they shall be qualified in this regard
              as a data controller and/or data processor. In this respect, the Parties warrants that they complies
              and shall comply with applicable data protection legislation in relation to all personal data
              processed by the Parties in respect of which they are a data controller and, if a Party processes
              personal data as a data processor, that the said Party has complied with all instructions from the
              data controller of such personal data. Furthermore, the Parties warrant that they fulfill all necessary
              requirements to inform data subjects of the processing of their personal data, including but not
              limited to the public notification with the competent authority where required under applicable
              data protection legislation. If applicable, the Parties shall ensure that their employees, ensigns,
              contractors, sub-contractors, users and other third parties are informed of the terms of the personal
              data protection and agree thereto.
            </li>
          </ul>
        </div>

        {/* 11. FORCE MAJEURE */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            11. FORCE MAJEURE
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>11.1.</span>{' '}
              The Parties shall be released from the liability for non-performance or improper performance of
              the obligations hereunder if circumstances of insuperable force arise, such as: adoption by the
              public authorities regulatory acts which essentially prevent the performance of these Terms &
              Conditions, earthquake, flood, fire, typhoon, hurricane, military actions, restrictions of transportations,
              trade ban with certain countries due to application of international sanctions, as well as existence of other
              similar circumstances beyond the Parties' will (hereinafter – force majeure).
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>11.2.</span>{' '}
              The Party affected by force majeure circumstances shall advise thereof the other Party within
              five calendar days following the day of their occurrence.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>11.3.</span>{' '}
              In case of force majeure circumstances, the deadlines for the Parties’ compliance with their
              undertakings under this Contract shall be extended pro rata the period of duration of
              such force majeure circumstances and/or their aftermath.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>11.4.</span>{' '}
              The Party referring to force majeure shall, to evidence its existence and impact, shall provide
              a document issued by a competent public authority or respective chamber of commerce and industry or its branch.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>11.5.</span>{' '}
              In case a force majeure event lasts for more than six months, each Party shall be entitled to
              rescind this Contract having returned to the other Party all the properties or funds
              received in advance for the purposes of fulfillment of this Contract before the date of its termination.
              Provided that neither Party shall demand to reimburse possible losses from the other Party.
            </li>
          </ul>
        </div>

        {/* 12. MISCELLANEOUS */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            12. MISCELLANEOUS
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>12.1.</span>{' '}
              The present Terms & Conditions will come in force on the date publication to the Digital
              Freight Alliance website at{' '}
              <a
                className={cn('item__link')}
                href='https://www.df-alliance.com'
              >
                www.df-alliance.com
              </a>{' '}
              and will be valid during one year from the date of publication, unless otherwise automatically prolonged.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>12.2.</span>{' '}
              Any amendments, addenda and appendices to the present Terms and Conditions as part of a signed
              Purchase Order between the Parties are considered as its integral part hereof and are valid
              only being made in writing and signed by duly authorized representative of both Parties and come
              in force from the moment of their signing.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>12.3.</span>{' '}
              Scanned, signed and stamped electronic copy of these Terms & Conditions and any accompanying
              Purchase Orders shall be considered valid by both Parties until such time as the Parties exchange
              their respective original copies hereof. All invoices issued by the Contractor and paid by the Client
              hereunder shall be deemed integral parts of these Terms & Conditions.
            </li>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>12.4.</span>{' '}
              The parties agree and understand that these Terms & Conditions may be updated from time to time.
            </li>
          </ul>
        </div>

        {/* 13. REFUND POLICY */}
        <div className={cn('item')}>
          <h2 className={cn('item__heading')}>
            13. REFUND POLICY
          </h2>
          <ul className={cn('item__list')}>
            <li className={cn('item__list-item')}>
              <span className={cn('item__bold')}>13.1.</span>{' '}
              All the membership fees are non-refundable and considered as a scope of services and 
              opportunities given and granted 100% at the moment of payment.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default SectionContent;